export class HashService {

  /*
   * Powered by
   * https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
   * aka 'BitShiftBingo'
   */
  static generate(value: string): number {
    const bitShifts = 5;
    let hash = 0;
    let char;

    for (let i = 0; i < value.length; i++) {
      char = value.charCodeAt(i);
      /* tslint:disable-next-line:no-bitwise */
      hash = ((hash << bitShifts) - hash) + char;
      /* tslint:disable-next-line:no-bitwise */
      hash = hash & hash; // Convert to 32bit integer
    }

    return hash;
  }
}
